const postFiltersEl = document.querySelector('.news-list__filter');
const newsListEl = document.querySelector('.news-list__row');
const placeholder = document.querySelector('.hero-sub-page__filter-placeholder');

// Update news list
const updateList = (listEl, listFooterEl, data) => {
  if (listEl && data.list__html) {
    listEl.dataset.page = data.page_number;
    if (parseInt(data.page_number) === 1) {
      listEl.innerHTML = data.list__html;
    } else {
      listEl.innerHTML += data.list__html;
    }
  }

  if (listFooterEl) {
    listFooterEl.classList.toggle('is-hidden', !data.load_more_posts);
  }
};

if (postFiltersEl && newsListEl) {
  // Axios get filtered post list
  const axiosGetFilteredPostList = async (page = 1, button = null) => {
    const formDataInput = {
      action: 'getFilteredPostList',
      page,
      category: postFiltersEl.querySelector('input[name="category"]:checked').id,
      brand: postFiltersEl.querySelector('input[name="brand"]:checked').id,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      updateList(newsListEl, document.querySelector('.news-list__footer'), response.data.data);

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['category', 'brand']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }

    if (button) {
      button.disabled = false;
    }
  };

  // Click event for dropdown list item
  attachEvent('.dropdown__list-item input', 'change', () => {
    axiosGetFilteredPostList();
  });

  // Stretch filter placeholder to bottom of news list
  const calcPlaceholderHeight = () => {
    if (placeholder) {
      const newsList = document.querySelector('.news-list');

      placeholder.style.height = `${
        newsList.getBoundingClientRect().bottom - placeholder.getBoundingClientRect().top
      }px`;
    }
  };
  calcPlaceholderHeight();
  window.addEventListener('resize', calcPlaceholderHeight);

  // Click event for load more button
  attachEvent('.news-list__load-more', 'click', (ev) => {
    ev.preventDefault();
    ev.target.disabled = true;
    const page = parseInt(newsListEl.dataset.page) + 1;
    axiosGetFilteredPostList(page, ev.target);
    calcPlaceholderHeight();
  });
}
